import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/mutation-grades'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(mutationGrade, uuid) {
    return http.post(`${resource}/${uuid}?_method=PUT`, mutationGrade)
  },
  add(mutationGrade) {
    return http.post(`${resource}`, mutationGrade)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
